export const extractBilibiliVideoParts = (url = "") => {
  const source = String(url || "").trim();
  const bvid = source.match(/BV[0-9A-Za-z]{10,}/)?.[0] || "";
  const aidMatch = source.match(/(?:\/video\/av|[?&]aid=|[?&]av=)(\d+)/i);
  const pageMatch = source.match(/[?&]p=(\d+)/i) || source.match(/[?&]page=(\d+)/i);

  return {
    bvid,
    aid: aidMatch?.[1] || "",
    page: Math.max(1, Number.parseInt(pageMatch?.[1] || "1", 10) || 1),
  };
};

export const getBilibiliEmbedUrl = (url = "", options = {}) => {
  const { bvid, aid, page } = extractBilibiliVideoParts(url);
  const params = new URLSearchParams({
    page: String(options.page || page || 1),
    high_quality: "1",
    danmaku: options.danmaku === true ? "1" : "0",
    autoplay: options.autoplay === true ? "1" : "0",
  });

  if (bvid) {
    params.set("bvid", bvid);
  } else if (aid) {
    params.set("aid", aid);
  } else {
    return "";
  }

  return `https://player.bilibili.com/player.html?${params.toString()}`;
};

export const isBilibiliUrl = (url = "") =>
  /(?:bilibili\.com|b23\.tv|BV[0-9A-Za-z]{10,}|\/video\/av\d+)/i.test(
    String(url || "")
  );
